// Percorso file: src/utils/calendario.js
//
// GLI AIUTANTI DI DATA E SETTIMANA — sede unica (giro G-K1, RD-219).
//
// Fino a qui questi corpi vivevano copiati, identici a token, in dieci file
// (`dataEvento` ×7, `evTimeStamp` ×5, `getWeekNumber` ×5, `getWeekRange` ×4,
// `localKey` ×2 più due in linea in Attendance.jsx). Sono ricopiati qui
// verbatim da CoachAttendance.jsx, senza alcun cambiamento di comportamento.
//
// ⚠️ NON sono qui, perché le loro copie NON sono identiche alle altre:
// `evTimeStamp` di CalendarClub.jsx (legge la data da sé, senza `dataEvento`)
// e di MyCalendar.jsx (parentesi in più nel ternario). Restano nelle loro
// pagine finché un cantiere non decide diversamente.
//
// ⚠️ MODULO PURO: nessun React, nessun import.

/** La data dell'evento nei due formati che i dati portano davvero:
 *  `YYYY-MM-DD` e `DD-MM-YYYY`, come data LOCALE. `null` se non si legge. */
export function dataEvento(ev) {
  if (!ev || !ev.date) return null;

  if (/^\d{4}-\d{2}-\d{2}$/.test(ev.date)) {
    const [y, m, d] = ev.date.split("-").map(Number);
    return new Date(y, m - 1, d);
  }
  if (/^\d{2}-\d{2}-\d{4}$/.test(ev.date)) {
    const [d, m, y] = ev.date.split("-").map(Number);
    return new Date(y, m - 1, d);
  }
  return null;
}

/** Istante dell'evento (data + ora), per l'ordinamento e il «già passato».
 *  Senza ora si intende la mezzanotte. */
export function evTimeStamp(ev) {
  const d = dataEvento(ev);
  if (!d) return 0;

  const t = ev.time && /^\d{2}:\d{2}$/.test(ev.time) ? ev.time : "00:00";
  const [hh, mm] = t.split(":").map(Number);
  d.setHours(hh, mm, 0, 0);
  return d.getTime();
}

/** Intervallo della settimana (lunedì → domenica) che contiene `date`. */
export function getWeekRange(date) {
  const day = date.getDay() || 7;
  const monday = new Date(date);
  monday.setDate(date.getDate() - day + 1);
  const sunday = new Date(monday);
  sunday.setDate(monday.getDate() + 6);
  return [
    monday.toLocaleDateString("en-AU", { day: "2-digit", month: "2-digit", year: "numeric" }),
    sunday.toLocaleDateString("en-AU", { day: "2-digit", month: "2-digit", year: "numeric" }),
    monday,
    sunday,
  ];
}

/** Numero di settimana ISO. */
export function getWeekNumber(date) {
  const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  const dayNum = d.getUTCDay() || 7;
  d.setUTCDate(d.getUTCDate() + 4 - dayNum);
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  return Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
}

/** Chiave LOCALE del giorno, `YYYY-MM-DD` (mai ISO/UTC: a Perth l'ISO di
 *  una mezzanotte locale è il giorno prima). */
export function localKey(d) {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}
